import { Button } from '@/components';
import { ButtonProps } from '@/components/atoms/Button/Button';
import { FC } from 'react';
interface CompositionButtonProps extends ButtonProps {
  clickHandler: () => void;
}
const CompositionButton: FC<CompositionButtonProps> = ({
  clickHandler,
  ...props
}) => {
  return (
    <Button
      icon={'ai'}
      intent={'ai'}
      iconStyles={{ intent: 'ai', size: 'md' }}
      onClick={clickHandler}
      {...props}
      className={`w-full ${props.className}`}
    >
      Personalize
    </Button>
  );
};
export default CompositionButton;
